module.exports = __webpack_public_path__ + "img/CB2-On-1.b8a4cfb2.gif";